import type { Address } from "@/stores/cartStore";

export const areAddressesSame = (address1: Address, address2: Address) => {
  return address1.first_name.toLowerCase() === address2.first_name.toLowerCase()
    && address1.last_name.toLowerCase() === address2.last_name.toLowerCase()
    && address1.address1.toLowerCase() === address2.address1.toLowerCase()
    && ((!address1.address2 && !address2.address2) || address1.address2.toLowerCase() === address2.address2.toLowerCase())
    && address1.city.toLowerCase() === address2.city.toLowerCase()
    && address1.country.toLowerCase() === address2.country.toLowerCase()
    && address1.province_code.toLowerCase() === address2.province_code.toLowerCase()
    && address1.zip.split('-')[0] === address2.zip.split('-')[0];
}